import React, { useCallback, useState, useEffect, useRef } from 'react'
import  emailjs  from  '@emailjs/browser'
import { createPortal } from "react-dom"
import styles from './ModalForm.module.scss'
import ModalOverlay from '../ModalOverlay/ModalOverlay'
import logo from '../../image/Header/logo (1).svg'
import { FormValidation } from '../../hooks/FormValidation'
import InputMask from "react-input-mask"

const ModalForm = ({onClose, popupOpen, isRus}) => {

    const modalRoot = document.getElementById("modals");
    
    const handleForm = FormValidation()
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const form = useRef()

    useEffect(() => {
        handleForm.isValid ? setButtonDisabled(false) : setButtonDisabled(true)
    }, [handleForm.isValid])

    const sendData = useCallback((evt) => {
        evt.preventDefault();
            emailjs.sendForm('service_2vtcfvs', 'template_0jnvkq9', form.current, 'FExKBUmWBw8Ots_be')
            .then(() => {
            }, (error) => {
                console.log(error.text);
            }); 
        onClose()
        handleForm.resetForm()
        popupOpen()
    }, [handleForm, onClose, popupOpen] )

    useEffect(() => {
        const handleEscClose = (evt) =>{
            if (evt.key ==='Escape')  onClose()
        }
        document.addEventListener('keydown', handleEscClose)
        return () => document.removeEventListener('keydown', handleEscClose)
    }, [onClose])

    return createPortal (
        <ModalOverlay onClick={onClose}>
            <div className={styles.modal} onClick={evt => evt.stopPropagation()}>
                <div className={styles.box_logo}>
                    <img className={styles.logo} src={logo} alt='логотип'/>
                    <button data-test="close-button" className={styles.close_icon} type="button" aria-label="закрыть" onClick={onClose}/>
                </div>
                <div className={styles.box}>
                    <h2 className={styles.title}>{ isRus  ? 'Оставьте ваши данные' : 'Leave your details'}</h2>
                    <p className={styles.subtitle}>{ isRus  ? 'Я свяжусь с вами в ближайшее время и отвечу на все вопросы!' : 'I will contact you soon and answer all your questions!'}</p>
                        <form className={styles.form} onSubmit={sendData} ref={form}>
                            <div className={styles.box_input}>
                                <label className={styles.label}>{ isRus  ? 'Введите имя' : 'Enter a name'}
                                    <input
                                        className={`${styles.input} ${handleForm.errors.name && styles.wrong}`}
                                        type='text' 
                                        name='name'
                                        value={handleForm.values.this}
                                        onChange={handleForm.handleChange} 
                                        pattern='^[A-Za-zА-Яа-яЁё\s\-]{2,30}$'  
                                        required/>
                                </label>
                            </div>
                            <span className={styles.input_error}>{handleForm.errors.name}</span>
                            <div className={styles.box_input}>
                            <label className={styles.label}>{ isRus  ? 'Введите телефон' : 'Phone number'}      
                                <InputMask
                                    className={`${styles.input} ${handleForm.errors.phone && styles.wrong}`}
                                    type='tel' 
                                    name='phone'
                                    value={handleForm.values.this}
                                    onChange={handleForm.handleChange}
                                    mask={'+7\\(999) 999-99-99'}  
                                    pattern='\+7\s?[\(][0-9]{3}[\)]?\s?\d{3}[-]?\d{2}[-]?\d{2}'
                                    required/>
                            </label>
                        </div>
                        <span className={styles.input_error}>{handleForm.errors.phone}</span> 
                        <div className={styles.box_textarea}>
                            <label className={styles.label_textarea}>{ isRus  ? 'Комментарий' : 'Comment'}
                                <textarea
                                    className={`${styles.textarea} ${styles.scrollbar}`}
                                    name='comment'
                                    value={handleForm.values.this}
                                    onChange={handleForm.handleChange}
                                    pattern='^[A-Za-zА-Яа-яЁё\s\-]{2,30}$'
                                    required
                                    />
                            </label>
                        </div>
                        <span className={styles.input_error}>{handleForm.errors.comment}</span>
                                    <button className={styles.button_form} type='submit'>{ isRus  ? 'жду звонка' : 'to send'} <span className={styles.glare}></span></button>
                        </form>
                        
                </div>
            </div>
        </ModalOverlay>
        ,modalRoot
    );
};

export default ModalForm